
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"m24.705 29.499-6.354-6.421L5.056 45.125 33.38 33.158l8.534 6.595-5.725-13.936-3.664 3.735-3.717-4.157z"}}),_c('g',{staticClass:"i-stroke",attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-miterlimit":"16"}},[_c('path',{staticClass:"i-stroke_2",attrs:{"d":"m9 44.296 17.785-32.57 7.942 3.88 9.978 25.369"}}),_c('path',{staticClass:"i-stroke_3",attrs:{"d":"m21.24 22.28 3.623 3.599 4.104-4.104 4.104 4.104 3.867-3.865"}}),_c('path',{staticClass:"i-stroke_4",attrs:{"d":"M30.627 13.027v.255-7.12h5.765l-.995 1.797.995 1.797h-5.627"}})]),_c('path',{staticClass:"i-Vector 133",attrs:{"stroke":"#234652","stroke-linecap":"square","d":"M14.457 29.184H5.754c-1.158 0-2.315-1.544-1.544-2.881.772-1.338 2.676-1.158 2.676-1.158s-.46-2.89 2.829-3.91c3.29-1.019 4.553 2.393 4.553 2.393s.727-.489 1.692-.354c.966.134 1.532.589 1.532.589"}})])
          )
        }
      }
    